module.exports = __webpack_public_path__ + "static/media/goback.101afecc.svg";